import React from "react";
import { number, bool, string } from "prop-types";

import Icon from "../icon";

const Telegram = ({ width = 28, height = 28, isShareRequired, text }) => (
  <Icon type="telegram" isShareRequired={isShareRequired} text={text}>
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 28 28">
      <g transform="translate(-826 -970)">
        <path d="M0 0H28V28H0z" transform="translate(826 970)" fill="transparent" />
        <g transform="translate(818.742 960.864)">
          <path
            d="M84.484 94.748c-.6 0-.5-.228-.709-.8L82 88.1 95.661 80"
            transform="translate(-66.607 -63.651)"
            fill="#C8E0EF"
          />
          <path
            d="M98 149.156a1.194 1.194 0 0 0 .931-.466l2.484-2.415-3.1-1.868"
            transform="translate(-80.123 -118.06)"
            fill="#C8E0EF"
          />
          <path
            fill="#ffffff"
            d="M56.855 83.393l7.507 5.547c.857.473 1.475.228 1.688-.8l3.056-14.4c.313-1.254-.478-1.823-1.3-1.451l-17.942 6.923c-1.225.491-1.218 1.175-.223 1.479l4.6 1.437L64.907 75.4c.5-.305.965-.141.586.2"
            transform="translate(-38.659 -57.043)"
          />
        </g>
      </g>
    </svg>
  </Icon>
);

Telegram.propTypes = {
  width: number,
  height: number,
  isShareRequired: bool,
  text: string,
};

export default Telegram;
